// methods copied from json-form-data and then customized

export function createFormData(jsonObject, options = {}, carryFormData = null) {
  let defaultOptions = {
    showLeafArrayIndexes: true,
  };

  let mergedOptions = mergeObjects(defaultOptions, options || {});

  return convertRecursively(
    jsonObject,
    mergedOptions,
    undefined,
    carryFormData
  );
}

function mergeObjects(object1, object2) {
  let objectsToMerge = [object1, object2];

  return objectsToMerge.reduce(function (carry, objectToMerge) {
    Object.keys(objectToMerge).forEach(function (objectKey) {
      carry[objectKey] = objectToMerge[objectKey];
    });

    return carry;
  }, {});
}

function isArray(val) {
  let toString = {}.toString;

  return toString.call(val) === "[object Array]";
}

function isObject(val) {
  return !isArray(val) && typeof val === "object" && !!val;
}

function convertRecursively(obj, options, parentKey, carryFormData = null) {
  let formData = carryFormData || new FormData();

  let index = 0;

  /** Send empty arrays too */
  if (isArray(obj) && obj.length === 0) {
    formData.append(parentKey, "[]");
  }

  for (let key in obj) {
    if (
      obj.hasOwnProperty(key) &&
      obj[key] !== null &&
      obj[key] !== undefined
    ) {
      let propName = parentKey || key;

      if (parentKey && isObject(obj)) {
        propName = parentKey + "[" + key + "]";
      }

      if (parentKey && isArray(obj)) {
        if (
          isArray(obj[key]) ||
          isObject(obj[key]) ||
          options.showLeafArrayIndexes
        ) {
          propName = parentKey + "[" + index + "]";
        } else {
          propName = parentKey + "[]";
        }
      }

      if (obj[key] instanceof File) {
        formData.append(propName, obj[key]);
      } else if (obj[key] instanceof FileList) {
        for (let j = 0; j < obj[key].length; j++) {
          formData.append(propName + "[" + j + "]", obj[key].item(j));
        }
      } else if (isArray(obj[key]) || isObject(obj[key])) {
        convertRecursively(obj[key], options, propName, formData);
      } else if (typeof obj[key] === "boolean") {
        formData.append(propName, obj[key]);
      } else {
        formData.append(propName, obj[key]);
      }
    }

    index++;
  }

  return formData;
}
